module.exports = __webpack_public_path__ + "img/document.1af77205.svg";